import React from "react";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import { ImageAttribution } from "../components/ImageAttribution";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SubComponentCard from "../components/SubComponent";

export default function Enrichment(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <ComponentCard
        title="Content"
        id="content"
        commentsCount={componentCommentsCount("content")}
      >
        <ComponentStepLabel number="1" title="Image:" />
        <ImageAttribution attribution={data.core.media} tl={tl} dir={dir} />
        <ComponentStepLabel number="2" title="Text:" />
        <Paper elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            <Grid item xs={12} className="m-0">
              <Typography
                className="wysiwyg m-0"
                dangerouslySetInnerHTML={{ __html: data.core.text }}
              />
            </Grid>
            <Grid item xs={12} className="m-0">
              <Typography className="m-0">{data.core.link}</Typography>
            </Grid>
            <Grid item xs={12} className="m-0">
              <Typography
                className="wysiwyg m-0"
                dangerouslySetInnerHTML={{ __html: data.core.conclusion }}
              />
            </Grid>
          </Grid>
        </Paper>
      </ComponentCard>
    </div>
  );
}
